<template>
  <div
    :class="{ correct, selected, incorrect: !correct }"
    class="correctness-box"
  >
    <div
      class="icon"
      :class="{ correct, selected, incorrect: !correct }"
    >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    correct: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    iconName() {
      if (this.correct) {
        return 'check-ffffff';
      } else if (this.selected) {
        return 'cross-ffffff';
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.correctness-box {
  min-height: 20px;
  max-height: 20px;
  min-width: 20px;
  max-width: 20px;
  border-radius: 2px;
  border: 0.833333px solid #00D8F8;
  box-sizing: border-box;
  overflow: hidden;
  background: white;

  &.correct {
    border: 4px solid #00B46D;
  }

  &.selected.incorrect {
    border: 4px solid #DC3416;
  }
}

.icon {
  margin: -5px 0 0 -5px;
  box-sizing: border-box;
  height: 22px;
  width: 22px;
  background-size: contain;
}

.icon.correct {
  @include correct-svg(#00B46D);
}

.icon.selected.incorrect {
  @include incorrect-svg(#DC3416);
}
</style>
